import { useState } from "react";
import Hackerbenner from "../../assests/tech/Hackerbenner.jpg";
import FixedImageWithToggleArrows from "./FixedElementWithToggle";
import BlurText from "./BlurText";
import Orb from "./Orb";
import RollingGallery from "./RollingGallery";

const Banner = () => {
  return (
    <>
      <div className="cyber-banner-container">
        <div className="orb-background">
          <Orb />
        </div>

        <div className="cyber-banner-left">
          <h1 id="textfont">
       
       <span id="colorChang">     <BlurText
              text="Wellcome  TO"
            
              delay={120}
              animateBy="words"
              direction="top"
              className="text-heading"
            /></span>
            <br />
            <span>
            <BlurText
              text="Hacker's  World"
              delay={120}
              animateBy="words"
              direction="top"
              className="text-subheading"
            /></span>
             {/* <RollingGallery
  text= "Wellcome To"
  enableWaves={true}
  asciiFontSize={8}
  
/><br/>
          <RollingGallery
  text= "Hacker's  World"
  enableWaves={true}
  asciiFontSize={8}
  
/> */}
          </h1>
          <p id="Z-indexVew">Please Contact to be a part of the event.</p>

          {/* WhatsApp Direct Link */}
          <a id="Z-indexVew"
            href="https://wa.me/8120851906?text=Hi!%20I%20want%20to%20register%20for%20CyberSec%20Connect."
            target="_blank"
            rel="noopener noreferrer"
          >
            <button>Contact Now</button>
          </a>
        </div>

        <div className="cyber-banner-right">
          <div className="cyber-image-circle">
            <img src={Hackerbenner} alt="Cybersecurity Expert" />
          </div>
        </div>
      </div>
      <FixedImageWithToggleArrows />
    </>
  );
};

export default Banner;
